import CityPageTemplate from "../city-template/CityPageTemplate";
import { medinaConfig } from "./data";

export default function MedinaPage() {
  return <CityPageTemplate config={medinaConfig} />;
}